
































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { IGetBookingDetailResponse } from '@/api/booking';
import BookingDetailTicket from './Ticket.vue';
import {
  IIssuingDetailWithValidation,
  IIssuingDetail,
  IssuedStatusEnum,
  IssuingRecordActionEnum,
  IssuingRule,
  IssuingRuleId,
  TicketWithAmountActionEnum,
} from '@/api/types';
import {
  IIssueRequest,
  IRefundRequest,
  IRevokeRequest,
  IRechargeRequest,
  issueTickets,
  refundTickets,
  revokeIssuedTickets,
  rechargeTickets,
} from '@/api/tickets';
import {
  formatDate,
  sleep,
  formatApiError,
  translateComponentResource,
  translatePluralResource,
} from '@/utils/index';
import {
  isActionCancelledNoSkip,
  issuingRecordIdForCancelActionNoSkip,
  formatIssuingRecordId,
  getParticipantName,
} from '@/utils/tickets';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'BookingDetailTickets',
  components: {
    MaterialCard,
    BookingDetailTicket,
  },
})
export default class BookingDetailTickets extends Vue {
  public static ticketsUpdatedEvent = 'update:booking-detail-tickets';
  private static defaultDialogAction = 'Issue';
  private static defaultDialogTicketsCount = 0;

  @Prop({ required: true }) data!: IGetBookingDetailResponse;
  private issuingTickets: {
    [ticketId: string]: IIssuingDetailWithValidation;
  } = {};
  private disableIssueButton = true;
  private disableRefundButton = true;
  private refundPermission = true;
  private disableRevokeButton = true;
  private disableRechargeButton = true;
  private disableByPartially = false;
  private disableIssueByPermission = false;
  private disableRefundByPermission = false;
  private noIssuePermissionTickets: string[] = [];
  private noRefundPermissionTickets: string[] = [];
  private dialog = false;
  private dialogAction = BookingDetailTickets.defaultDialogAction;
  private dialogTicketsCount = BookingDetailTickets.defaultDialogTicketsCount;
  private dialogConfirmHandler = this.resetDialog;

  get bookingId() {
    return this.data.booking.bookingId;
  }

  get bundleBookingParentId() {
    return this.data.booking.bundleBookingParentId;
  }

  get productName() {
    return `${this.data.booking.activityTitle} | ${this.data.booking.planTitle}`;
  }

  get planStartTime() {
    return this.data.booking.planStartTime;
  }

  get participantName() {
    return getParticipantName(
      this.data.booking.participantFirstName as string,
      this.data.booking.participantLastName as string,
      AppModule.language
    );
  }

  get agentName() {
    return this.data.booking.agentName;
  }

  get ticketIssueCountUpdatedEvent() {
    return BookingDetailTicket.ticketIssueCountUpdatedEvent;
  }

  get issuingRecordIdForRevoke() {
    return issuingRecordIdForCancelActionNoSkip(
      IssuingRecordActionEnum.REVOKE,
      this.data.issuedStatus,
      this.data.issuingLogs
    );
  }

  get issuingRecordIdForRecharge() {
    return issuingRecordIdForCancelActionNoSkip(
      IssuingRecordActionEnum.RECHARGE,
      this.data.issuedStatus,
      this.data.issuingLogs
    );
  }

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  created() {
    this.updateDisableButtons();
  }

  private updateDisableButtons() {
    this.updateDisableByPartially();
    this.updateDisableByPermission();
    this.updateDisableIssueButton();
    this.updateDisableRefundButton();
    this.updateDisableRevokeButton();
    this.updateDisableRechargeButton();
  }

  private updateDisableByPartially() {
    if (
      this.data.issuingRules &&
      this.data.issuingRules.some(
        r => (r.id as IssuingRuleId) === IssuingRuleId.CANNOT_PARTIALY_ISSUE
      )
    ) {
      let total = 0;
      this.data.tickets.forEach(t => {
        t.issuableTickets.forEach(issuable => (total += issuable.amount));
      });
      Object.values(this.issuingTickets).forEach(t => (total -= t.amount));
      if (total !== 0) {
        this.disableByPartially = true;
        return;
      }
    }
    this.disableByPartially = false;
    return;
  }

  private updateDisableByPermission() {
    let disableIssueByPermission = false;
    let disableRefundByPermission = false;
    let noIssuePermissionTickets: string[] = [];
    let noRefundPermissionTickets: string[] = [];

    for (let i = 0; i < this.data.tickets.length; i++) {
      if (
        this.issuingTickets[this.data.tickets[i].ticketId] &&
        this.issuingTickets[this.data.tickets[i].ticketId].amount !== 0
      ) {
        (this.data.tickets[i].forbiddenActions || []).forEach(a => {
          if (
            (a as TicketWithAmountActionEnum) ===
            TicketWithAmountActionEnum.TICKET_ISSUE
          ) {
            disableIssueByPermission = true;
            noIssuePermissionTickets.push(this.data.tickets[i].title);
          } else if (
            (a as TicketWithAmountActionEnum) ===
            TicketWithAmountActionEnum.TICKET_REFUND
          ) {
            disableRefundByPermission = true;
            noRefundPermissionTickets.push(this.data.tickets[i].title);
          }
        });
      }
    }

    this.disableIssueByPermission = disableIssueByPermission;
    this.disableRefundByPermission = disableRefundByPermission;
    this.noIssuePermissionTickets = noIssuePermissionTickets;
    this.noRefundPermissionTickets = noRefundPermissionTickets;
  }

  private updateDisableIssueButton() {
    if (
      (this.data.issuedStatus as IssuedStatusEnum) ===
        IssuedStatusEnum.DISABLE ||
      (this.data.issuedStatus as IssuedStatusEnum) === IssuedStatusEnum.ISSUED
    ) {
      this.disableIssueButton = true;
      return;
    }
    this.disableIssueButton =
      Object.values(this.issuingTickets).length === 0 ||
      Object.values(this.issuingTickets).some(t => !t.valid) ||
      Object.values(this.issuingTickets).every(t => t.amount == 0) ||
      this.disableByPartially ||
      this.disableIssueByPermission;
  }

  private updateDisableRefundButton() {
    if (
      (this.data.issuedStatus as IssuedStatusEnum) ===
        IssuedStatusEnum.DISABLE ||
      (this.data.issuedStatus as IssuedStatusEnum) === IssuedStatusEnum.ISSUED
    ) {
      this.disableRefundButton = true;
      return;
    }
    this.disableRefundButton =
      Object.values(this.issuingTickets).length === 0 ||
      Object.values(this.issuingTickets).some(t => !t.valid) ||
      Object.values(this.issuingTickets).every(t => t.amount == 0) ||
      this.disableByPartially ||
      this.disableRefundByPermission;
  }

  private updateDisableRevokeButton() {
    this.disableRevokeButton = this.issuingRecordIdForRevoke ? false : true;
  }

  private updateDisableRechargeButton() {
    this.disableRechargeButton = this.issuingRecordIdForRecharge ? false : true;
  }

  private handleTicketIssueCountUpdated(data: IIssuingDetailWithValidation) {
    this.issuingTickets[data.ticketId] = data;
    this.updateDisableButtons();
  }

  private async handleIssue() {
    const req = {
      bookingId: this.data.booking.bookingId,
      bookingRecordVersion: this.data.version,
      details: [],
    } as IIssueRequest;
    Object.values(this.issuingTickets).forEach(t => {
      if (t.valid && t.amount != 0) {
        req.details.push({
          ticketId: t.ticketId,
          amount: t.amount,
        } as IIssuingDetail);
      }
    });
    AppModule.ShowOverlay();
    try {
      const res = await issueTickets(req);
      this.$toast.success(
        `${this.$t('Issued')}, ${this.$t('Id')}: ${formatIssuingRecordId(
          res.issuingRecordId
        )}`,
        {
          icon: 'mdi-check-circle',
        }
      );
      this.$emit(BookingDetailTickets.ticketsUpdatedEvent);
      AppModule.HideOverlay();
    } catch (err) {
      AppModule.HideOverlay();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Issue') as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async handleRefund() {
    const req = {
      bookingId: this.data.booking.bookingId,
      bookingRecordVersion: this.data.version,
      details: [],
    } as IRefundRequest;
    Object.values(this.issuingTickets).forEach(t => {
      if (t.valid && t.amount != 0) {
        req.details.push({
          ticketId: t.ticketId,
          amount: t.amount,
        } as IIssuingDetail);
      }
    });
    try {
      AppModule.ShowOverlay();
      const res = await refundTickets(req);
      this.$toast.success(
        `${this.$t('Refunded')}, ${this.$t('Id')}: ${formatIssuingRecordId(
          res.issuingRecordId
        )}`,
        {
          icon: 'mdi-check-circle',
        }
      );
      this.$emit(BookingDetailTickets.ticketsUpdatedEvent);
      AppModule.HideOverlay();
    } catch (err) {
      AppModule.HideOverlay();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Refund') as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async handleRevoke() {
    const req = {
      bookingId: this.data.booking.bookingId,
      bookingRecordVersion: this.data.version,
      issuingRecordId: this.issuingRecordIdForRevoke,
    } as IRevokeRequest;
    try {
      AppModule.ShowOverlay();
      const res = await revokeIssuedTickets(req);
      this.$toast.success(
        `${this.$t('Revoked')}, ${this.$t('Id')}: ${formatIssuingRecordId(
          res.issuingRecordId
        )}`,
        {
          icon: 'mdi-check-circle',
        }
      );
      this.$emit(BookingDetailTickets.ticketsUpdatedEvent);
      AppModule.HideOverlay();
    } catch (err) {
      AppModule.HideOverlay();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Revoke') as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async handleRecharge() {
    const req = {
      bookingId: this.data.booking.bookingId,
      bookingRecordVersion: this.data.version,
      issuingRecordId: this.issuingRecordIdForRecharge,
    } as IRechargeRequest;
    try {
      AppModule.ShowOverlay();
      const res = await rechargeTickets(req);
      this.$toast.success(
        `${this.$t('Recharged')}, ${this.$t('Id')}: ${formatIssuingRecordId(
          res.issuingRecordId
        )}`,
        {
          icon: 'mdi-check-circle',
        }
      );
      this.$emit(BookingDetailTickets.ticketsUpdatedEvent);
      AppModule.HideOverlay();
    } catch (err) {
      AppModule.HideOverlay();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Recharge') as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private resetDialog() {
    this.dialog = false;
    this.$nextTick(() => {
      this.dialogAction = BookingDetailTickets.defaultDialogAction;
      this.dialogTicketsCount = BookingDetailTickets.defaultDialogTicketsCount;
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForIssue() {
    this.dialogAction = 'Issue';
    let count = 0;
    Object.values(this.issuingTickets).forEach(d => (count += d.amount));
    this.dialogTicketsCount = count;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.handleIssue();
    };
    this.dialog = true;
  }

  private showDialogForRefund() {
    this.dialogAction = 'Refund';
    let count = 0;
    Object.values(this.issuingTickets).forEach(d => (count += d.amount));
    this.dialogTicketsCount = count;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.handleRefund();
    };
    this.dialog = true;
  }

  private translateComponentResource(
    resource: string,
    options?: { [key: string]: any }
  ) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource,
      options
    );
  }

  private translatePluralResource(resource: string, n: number) {
    return translatePluralResource(this.$i18n, resource, n);
  }
}
